import React from "react";
import { Link } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ReportsModal = ({ isOpen, onClose, reports }) => {
	if (!isOpen) {
		return null;
	}
	const closeModal = (e) => {
		if (e.target.classList.value === "modal show") {
			onClose();
		}
	};

	const categorisedReports = reports.reduce((acc, report) => {
		const species = report.species;
		if (!acc[species]) {
			acc[species] = [];
		}
		acc[species].push(report);
		return acc;
	},{})

	return (
		<>
			<div
				className="modal show"
				id="mojListModal"
				tabIndex="-1"
				aria-labelledby="mojListModal"
				aria-modal="true"
				role="dialog"
				style={{ display: "block" }}
				onClick={closeModal}
			>
				<div className="modal-dialog modal-dialog-scrollable modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h5
								className="modal-title"
								id="dwpListModalTitle"
								style={{ fontSize: "18px" }}
							>
								Reports in this category ({reports.length})
							</h5>

							<button
								type="button"
								className="close"
								data-dismiss="modal"
								onClick={onClose}
								aria-label="Close"
								id="closeModal"
							>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<ul
								style={{
									listStyleType: "none",
									paddingLeft: "0px",
								}}
							>
								{reports.length > 0 ? (
									Object.keys(categorisedReports).map((species) => (
										<Accordion
											defaultExpanded
										>
											<AccordionSummary
												style={{background:"#28525e", color:"white"}}
												expandIcon={<ArrowDropDownIcon style={{color:"white"}}/>}
											>
												{species} ({categorisedReports[species].length})
											</AccordionSummary>
											<AccordionDetails>
												{categorisedReports[species].map((report, index) => (
													<div
														key={
															"key" +
															report.id +
															"_" +
															index
														}
														className="modal-link report-links"
													>
														<Link
															to={{
																pathname: `/report/${report.covidence}`,
															}}
															state={{
																otherReports: reports,
															}}
															className="modal-link report-links"
														>
															<li>
																{report.title +
																	" - " +
																	report.authors +
																	" (" +
																	report.year +
																	")" +
																	" " +
																	report.journal}
															</li>
															<hr />
														</Link>
													</div>
												))}
											</AccordionDetails>
										</Accordion>
									))
								) : (
									<div>No reports found</div>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-backdrop show"></div>
		</>
	);
};

export default ReportsModal;
